<template>
    <div class="flex mt-3 p-1">
        <!-- <vs-input
            readonly
            :disabled="disabled"
            :label-placeholder="placeholder"
            v-model="model"
            class="form-control w-full"
            ref="adte"
            type="text"
        />
        <vs-button
            class="custom_clear_button"
            @click="clearModel"
            v-if="!disabled && mobileVer"
            type="flat"
        >
            <vx-tooltip :text="$t('clear')"> x </vx-tooltip>
        </vs-button> -->

        <div class="p-1 flex flex-col w-full" style="margin-top: -1.1rem">
            <span class="label">{{ placeholder }}</span>
            <flat-pickr
                :config="configDateTimePicker"
                :placeholder="placeholder"
                :disabled="disabled"
                v-model="model"
            />
        </div>
    </div>
</template>

<script>
import "@/localNodeModules/RollDate/rolldate.min.js";

import { Russian } from "flatpickr/dist/l10n/ru";
import { Kazakh } from "flatpickr/dist/l10n/kz";
export default {
    name: "DatepickerCustom",
    props: {
        value: {
            type: String,
        },
        customFormat: {
            type: String,
            default: "Y-m-d",
        },
        placeholder: {
            type: String,
            required: true,
        },
        addYear: {
            type: Number,
            default: 0,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            rollDates: {
                picker: null,
                backUpModel: "",
            },
            configDateTimePicker: {
                enableTime: false,
                dateFormat: this.customFormat,
                // locale: this.$i18n.locale === "kk" ? "kz" : this.$i18n.locale,
            },
        };
    },
    mounted() {
        // this.rollDates.picker = new Rolldate(this.config);
    },
    computed: {
        mobileVer() {
            return this.$store.state.windowWidth < 768;
        },
        model: {
            get() {
                return  this.value;
                // ? this.$moment(this.value).format("DD MMMM YYYY")
                // : "";
            },
            set(value) {
                // var reverse = value?value.split("-").reverse().join(" "):"";
                // console.log('set reverse',reverse)

                this.$emit("input", value);
            },
        },
        config() {
            return {
                el: this.$refs.adte,
                format: this.customFormat,
                beginYear: 1900,
                endYear: 2030,
                lang: this.$t("datePicker"),
                confirm: (date) => {
                    // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                    this.model = date;
                },
            };
        },
    },
    methods: {
        clearModel() {
            this.model = "";
        },
    },
    watch: {
        // $route: {
        //     handler() {
        //         this.rollDates.picker.extend(this.config);
        //     },
        //     deep: true,
        // },
    },
};
</script>

<style scoped lang="scss">
.custom_clear_button {
    margin-top: 17px;
    margin-left: 5px;
    min-width: 15%;
    border: 0;
    font-size: 16px;
    background: white;
    border-radius: 7px;
    cursor: pointer;
    transition: 0.3s;
    color: rgba(var(--vs-primary), 1) !important;

    &:hover {
        box-shadow: 0 0 3px #adadad;
    }
}
.label {
    padding-left: 0.5rem !important;
    padding: 0.5rem !important;
    font-size: 0.7rem;
    border-radius: 5px;
    color: rgba(0, 0, 0, 0.4);
}
</style>
